import { useState } from "react";
import { ActionSlot, Card } from "~/business";
import { contextFactory } from "~/utils";

export type SelectionProps = {
  card?: Card;
  actionSlot?: ActionSlot;
};

export type SelectionContext = SelectionProps & {
  clear: () => void;
  selectCard: (card: Card | undefined) => void;
  selectActionSlot: (card: ActionSlot | undefined) => void;
};

export const { Provider: SelectionProvider, useCustomContext: useSelection } =
  contextFactory<SelectionContext>(function selectionContext() {
    const [selection, setSelection] = useState<SelectionProps>({});
    const clear = () => setSelection({});
    const genericSelect =
      (key: keyof SelectionProps) =>
      (value: SelectionProps[typeof key] | undefined) => {
        if (selection[key] === value) {
          setSelection({ ...selection, [key]: undefined });
        } else {
          setSelection({ ...selection, [key]: value });
        }
      };

    const selectCard = genericSelect("card");
    const selectActionSlot = genericSelect("actionSlot");

    return { ...selection, clear, selectCard, selectActionSlot };
  });
